/**
 * Compensafe Report v1.1
 *
 * Depends On:
 *  JQuery 1.7.2
 *  JQueryUI 1.8.19
 *  DataTables
 *  formatting.js
 *      - jquery.numberformatter-1.2.3.js
 *          - jshashtable-2.1.js
 *  JSON.parseWithDate.js
 *  Compensafe DateRange        (jquery.compensafe.DateRange.js)
 *  Compensafe Branch/Employee  (jquery.compensafe.BranchEmployee.js)
 *  Compensafe Loading Message  (jquery.compensafe.loadingmsg.js)
 *  Compensafe Report Directory (jquery.compensafe.reportdir.js)
 *  Compensafe Auth Token Svc   (tokenAuthorization.js)
 *
 *  Options:
 *
 *  Public API:
 *
 */
(function ($) {
    // Add reports that have been moved to this set so the correct api is called
    const reportsMovedToIcApi = new Set(
        [
            "AERanking",
            "AL5WithPay",
            "AuditClosedRptCommID",
            "AuditEmpAssignmentsMissingSAO",
            "AuditEmpCommEmpOverride",
            "AuditEmpPayTranLate",
            "AuditEmpPayTranLateDetail",
            "AuditKeyLoanChangesAfterLockdown",
            "AuditManagersOrLoanOriginatorsNotYetLoggedInAndActive",
            "AuditMissingEmployee",
            "AuditMultipleCompensation",
            "AuditMultipleRoles",
            "AuditNegPayroll",
            "AuditNewBranches",
            "AuditNewUsers",
            "AuditPosPayrollandBalance",
            "AuditPossibleDuplicateEmployeeProfiles",
            "AuditTerminatedLOs",
            "AuditUserPasswordsSentOut",
            "AuditUsersActiveButNotAllowedToLogin",
            "AuditUsersLog",
            "AuditUsersWithExecutiveLevelAccess",
            "AuditUsersWithIncorrectCompanyEmailDomains",
            "AutoDraws",
            "AutoDrawTiming",
            "BestMonthSummaryBranchReport",
            "BestMonthSummaryLOReport",
            "Bonuses",
            "BranchChangeReport",
            "BranchDetails",
            "BranchDirectory",
            "BranchMeasure",
            "BranchMetrics",
            "BranchWithNoManager",
            "BrRanking",
            "CompanyLevelMetrics",
            "CompanyMeasure",
            "CompanyParams",
            "CompensationConfirmations",
            "CompensationConfirmationsAll",
            "CompensationScheduleTierDetails",
            "CompensationSnapshotSummary",
            "CompensationSummaryPerAllEmp",
            "CompensationSummaryPerEmp",
            "CompensationSummaryPerEmpPayroll",
            "CompletedByBrokerAndInvestor",
            "Disbursements",
            "DiscretionaryBonusSummary",
            "DrawsPaid",
            "DrawStatus",
            "DrawsUnpaid",
            "EmpDocumentDetail",
            "EmployeeAccessLevelandHierarchy",
            "EmployeeAccessReview",
            "EmployeeChangeReport",
            "EmployeeDetails",
            "EmployeeDirectory",
            "EmployeeGoalPlanDetails",
            "EmployeeGoalPlanTierDetails",
            "EmployeeIncentivePlanDetails",
            "EmployeeIncentivePlanTierDetails",
            "EmployeeStandardPlanTierDetails",
            "EmployeeMetrics",
            "EmployeeStandardPlanDetails",
            "EmployeeRelationships",
            "FundedByTypePurpReport",
            "GetCompletedLoansByPropertyLocation",
            "GoalPlanDetails",
            "GoalPlansByEmployee",
            "HeadcountReport",
            "HeldPayTransactionsByActive",
            "HeldPayTransactionsByInactive",
            "HeldPayTransactionsByPosted",
            "IncentivePlanFilters",
            "IncentivePlanScenario",
            "IntegrationLog",
            "InvoiceLoanDetails",
            "LeadReferralSources",
            "LoanAssignmentsByApplicationDate",
            "LoanAssignmentsByCompletedDate",
            "LoansCompleted",
            "LoansCompletedByBranch",
            "LoansPaidBySAOReport",
            "LoansWithMetricsApplic",
            "LoansWithMetricsCompleted",
            "LoansWithMissingInformation",
            "LoanVolumebyAssignmentRole",
            "LoanVolumebyProcessor",
            "LoanVolumeByUW",
            "LOProductivityByBranch",
            "LORanking",
            "LORankingAll",
            "LoSummaryCommission",
            "ManagerAccessReview",
            "ManualDisbursement",
            "MarketingAccountBalance",
            "MarketingAccountTransaction",
            "MarketingBalanceDetails",
            "MetricPayments",
            "MinGuaranteeReport",
            "StandardPlanDetails",
            "StandardPlanFilters",
            "StandardPlansByEmployee",
            "Overrides",
            "OverrideSchedOverview",
            "OverrideSchedulePayTiming",
            "OverrideTransactions",
            "PayrollIncentivesSummary",
            "PayrollPeriods",
            "PayrollSummaryByLoan",
            "PayrollTransactions",
            "PayrollTransactionsSAO",
            "PayrollTransactionsWithOverrideDetails",
            "PendingUplDrawAmtAudit",
            "PlanAssignmentChangeReport",
            "RealEstateAgents",
            "RecoverableDrawBalance",
            "RegionDetails",
            "RegionDirectory",
            "RegRanking",
            "RevenueBranchSummary",
            "RevenueDetail",
            "ScorecardBrAverages",
            "ScorecardLOAverages",
            "SettledManualDisbursements",
            "SystemEmailsRpt",
            "TerminatedEmployeeBalances",
            "WatchList",
            "ZeroLoanAudit",
        ],
    )
    
    $.widget("compensafe.report",
        {
            options:
            {
                baseUrl: null,
                title: '',
                dateRange: function () { var rc = null; if (new Date().getDate() < 2) rc = 'prev'; else rc = 'mtd'; return rc; },
                regionID: null,
                branchID: null,
                employeeID: null,
                dateRanges: null, // if null then plugin will use defaults
                active: 1,
                reportID: null,
                category: 'default',
                accessLevel: null,
                queryString: null,
                showDateRangePicker: true,
                showRegionBranchEmployee: true,
                showActive: true,
                activeLabel: '',
                employeeTypes: 'ALL', //ALL, LO
                byLoanTypeGroup: false,
                startDay: null,
                endDay: null,
                payCalendars: [],
                payCalendarID: 0,
                payPeriodOffset: 0,
                payPeriodOffsetMode: 'paydate'
            },
            _create: function () {
                var self = this;
                self._createPrefix();

                self.element.addClass('ui-widget');
                self.element.addClass('compensafe-report');

                var htmlTemplate =
                    '<div class="row"><h2 id="' + self._id('title') + '" class="col-md-9" data-cy="report-title"></h2>' +
                    '<div id="' + self._id('reportListContainer') + '" class="col-md-3">' +
                    '<button id="' + self._id('reports') + '" class="btn btn-sm btn-default">Report Directory</button>' +
                    '</div></div>' +
                    '<div class="row"><div class="col-md-7">' +
                    '<div id="' + self._id('be') + '" class="compensafe-report-be"></div>' +
                    '</div><div class="col-md-5">' +
                    '<div id="' + self._id('dr') + '" class="compensafe-report-dr"></div>' +
                    '<div id="' + self._id('active-control') + '">' +
                    '<label><span id="' + self._id('active-label') + '"></span>&nbsp;<div id="' + self._id('active-group') + '" class="btn-group" role="group" data-toggle="buttons">' +
                    '<label class="btn btn-sm btn-default"><input type="radio" name="report-active" value="1">Active</label>' +
                    '<label class="btn btn-sm btn-default"><input type="radio" name="report-active" value="0">Inactive</label>' +
                    '<label class="btn btn-sm btn-default"><input type="radio" name="report-active" value="2">All</label>' +
                    '</div ></label></div></div></div>' +
                    '<table id="' + self._id('results') + '" style="width:100%" class="compensafe-report-results table table-striped table-bordered" data-cy="report-table"></table>' +
                    '<div id="' + self._id('loadingmsg') + '"></div>' +
                    '<div id="' + self._id('reportsdlg') + '" style="display:none" class="compensafe-report-dlg"></div>';
                var $dr = $(htmlTemplate);
                self.element.append($dr);

                var jqAg = $('#' + self._id('active-group') + ' input[type="radio"][name="report-active"]');
                var jqReports = $('#' + self._id('reports'));
                var jqReportsDlg = $("#" + self._id('reportsdlg'));

                $('#' + self._id('loadingmsg')).loadingMsg();

                // add click handler for report directory hyperlinks
                jqReportsDlg.on("click", "a.cs-rptdir-itemlink:not(.rpt-external)", function (e) {
                    e.preventDefault();
                    self.options.reportID = $(this).attr("rid");
                    self.options.reportIDChanged = true;
                    jqReportsDlg.dialog("close");
                    self._reportInputChanged();
                });

                jqReports.on('click', function (e) {
                    e.preventDefault();
                    jqReportsDlg
                        .reportdir({ baseUrl: self.options.baseUrl, csApiUrl: csApiUrl })
                        .dialog({ width: "40%", title: "Report Directory" });
                });

                // CS-16824:  Added support for hiding the "Report Directory"
                //            This is controlled using the session variable "ShowReportDirectoryButton"
                if (!showReportDirectoryButton)
                    $('#' + self._id('reports')).hide();

                self.options.reportIDChanged = true;

                if ((self.options.queryString) && (typeof (self.options.queryString) !== "undefined")) {
                    self._paramParse(self.options.queryString);
                }

                self.branchEmployeeOp =
                {
                    baseUrl: self.options.baseUrl,
                    accessLevel: self.options.accessLevel,
                    regionID: self.options.regionID,
                    branchNumber: self.options.branchNumber,
                    branchID: self.options.branchID,
                    employeeID: self.options.employeeID,
                    initialloadcomplete: function () {
                        self._reportInputChanged();
                    },
                    change: function () {
                        self._reportInputChanged();
                    },
                    employeeTypes: self.options.employeeTypes
                };

                if (self.options.accessLevel <= 1) {
                    $('#' + self._id('be')).hide();
                    self.branchEmployeeOp.showBranchSelector = false;
                    self.branchEmployeeOp.showEmployeeSelector = false;
                }

                if (self.options.accessLevel < 5) {
                    self.branchEmployeeOp.showRegionSelector = false;
                }
                else {
                    self.branchEmployeeOp.showRegionSelector = true;
                }

                self.dateRangeOp =
                {
                    dateRange: self.options.dateRange,
                    dateRanges: [],
                    disableChangeEvent: true,
                    change: function () {
                        self._reportInputChanged();
                    }
                };

                if (self.options.dateRanges === null) {
                    self.options.dateRanges =
                        [
                            { label: 'Prev', value: 'prev' },
                            { label: 'MTD', value: 'mtd' },
                            { label: 'QTD', value: 'qtd' },
                            { label: '1m', value: '1m' },
                            { label: '3m', value: '3m' },
                            { label: '6m', value: '6m' },
                            { label: 'YTD', value: 'ytd' },
                            { label: '1y', value: '1y' }
                        ];
                }

                self.dateRangeOp.dateRanges = self.options.dateRanges;

                jqAg.filter('[value="' + self.options.active + '"]').closest('label').bootstrapBtn('toggle');
                jqAg.on('change', function () {
                    self._reportInputChanged();
                });

                self._reportInputChanged();
            },
            _createPrefix: function () {
                var self = this;
                // if element has an id, then use that for prefix
                var id = self.element.attr('id');
                if (id == null) {
                    id = self.widgetBaseClass + parseInt(Math.random() * 10000);
                }

                self.options.prefix = id + '-';
            },
            _id: function (id) {
                var self = this;
                return self.options.prefix + id;
            },
            _url: function (url) {
                var self = this;
                var rc;
                if (url != null && url.indexOf("~/") == 0) {
                    rc = "" + self.options.baseUrl + url.substring(2);
                }
                else {
                    rc = "" + self.options.baseUrl + url;
                }
                return rc;
            },
            _paramParse: function (url) {
                var self = this;

                if (typeof url === 'undefined' || null === url) {
                    return {};
                }

                var queryStartIndex = url.indexOf("?");
                if (queryStartIndex == -1) return {};
                var fr = url.indexOf("#");
                var query = "";
                query = (fr == -1) ? url.substr(queryStartIndex + 1) : url.substr(queryStartIndex + 1, fr - queryStartIndex - 1);
                var parts = query.split("&");
                var vars = {};

                for (var i = 0; i < parts.length; i++) {
                    var p = parts[i].split("=");

                    if (p[1]) {
                        vars[decodeURIComponent(p[0].toUpperCase())] = decodeURIComponent(p[1]);
                    } else {
                        vars[decodeURIComponent(p[0].toUpperCase())] = "";
                    }

                    switch ((decodeURIComponent(p[0].toUpperCase()))) {
                        case 'REGIONID':
                        case 'REGID':
                            self.options.regionID = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                        case 'BRANCHID':
                        case 'BRID':
                            self.options.branchID = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                        case 'BRNO':
                            self.options.branchNumber = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                        case 'EMPLOYEEID':
                        case 'EMPID':
                            self.options.employeeID = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                        case 'FROMDATE':
                            self.options.dateRange.from = new Date(vars[decodeURIComponent(p[0]).toUpperCase()]);
                            self.options.payrollDateRange.from = new Date(vars[decodeURIComponent(p[0]).toUpperCase()]);
                            break;
                        case 'TODATE':
                            self.options.dateRange.to = new Date(vars[decodeURIComponent(p[0]).toUpperCase()]);
                            self.options.payrollDateRange.to = new Date(vars[decodeURIComponent(p[0]).toUpperCase()]);
                            break;
                        case 'PAYCALENDARID':
                            self.options.payCalendarID = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                        case 'ACTIVE':
                            self.options.active = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                        case 'BYLOANTYPEGROUP':
                            self.options.byLoanTypeGroup = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                        case 'STARTDAY':
                            self.options.startDay = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                        case 'STOPDAY':
                            self.options.stopDay = vars[decodeURIComponent(p[0]).toUpperCase()];
                            break;
                    }
                }

                self.vars = vars;

                return vars;
            },
            _populateResults: function () {
                var self = this;
                var reportParams = self.getReportParams();
                var reportID = reportParams.reportID;
                // branch and employee have to load by ajax so make sure we have
                // values before querying
                if (reportParams !== null && typeof (reportParams) !== "undefined"
                    && reportParams.notFinishedLoading !== true
                    && reportParams.reportID !== null && typeof (reportParams.reportID) !== "undefined"
                    && reportParams.branchID !== null && typeof (reportParams.branchID) !== "undefined"
                    && reportParams.employeeID !== null && typeof (reportParams.employeeID) !== "undefined") {
                    //remap params to web service param names
                    reportParams =
                    {
                        ID: reportID,
                        FromDate: reportParams.from,
                        ToDate: reportParams.to,
                        PayCalendarID: reportParams.payCalendarID,
                        PayPeriodOffset: reportParams.payPeriodOffset,
                        PayPeriodOffsetMode: reportParams.payPeriodOffsetMode,
                        RegionID: reportParams.regionID,
                        BranchID: reportParams.branchID,
                        EmployeeID: reportParams.employeeID,
                        Active: reportParams.active,
                        Params: self._paramParse(self.options.queryString),
                    };

                    $('#' + self._id('loadingmsg')).loadingMsg("show");

                    var authToken = authTokenService.getUserToken();
                    $.ajax({
                        type: reportsMovedToIcApi.has(reportParams.ID) ? 'GET' : 'POST',
                        url: reportsMovedToIcApi.has(reportParams.ID) ? `${self.options.csApiUrl}/reports/${reportParams.ID}/structure` : self._url('Reporting/ReportData.asmx/RunReport'),
                        headers: { 'X-AuthBearer': authToken },
                        data: JSON.stringify(reportParams),
                        contentType: 'application/json; charset=utf-8',
                        dataType: 'json',
                        success: function (response) {
                            var d = authCommonResponse.get(response);
                            $('#' + self._id("title")).text(d.d.Title);
                            self._populateResultsFromData(d.d);

                            // change help text
                            if (d.d.HelpDoc !== null && typeof d.d.HelpDoc !== 'undefined') {
                                SetHelpDocuments(self._url(d.d.HelpDoc.Url));
                            }
                            else {
                                SetHelpDocuments(null);
                            }

                            $('#' + self._id('loadingmsg')).loadingMsg("hide");
                        }
                    });
                }
            },
            _populateResultsFromData: function (data) {
                var self = this;
                self.options.curData = data;
                var reportParams = self.getReportParams();
                var reportID = reportParams.reportID;
                var qsparams = self._paramParse(self.options.queryString);

                reportParams =
                {
                    ID: reportID,
                    FromDate: reportParams.from,
                    ToDate: reportParams.to,
                    PayCalendarID: reportParams.payCalendarID,
                    PayPeriodOffset: reportParams.payPeriodOffset,
                    PayPeriodOffsetMode: reportParams.payPeriodOffsetMode,
                    Active: reportParams.active,
                    RegionID: reportParams.regionID,
                    BranchID: reportParams.branchID,
                    EmployeeID: reportParams.employeeID,
                    AdditionalParamsList: Object.keys(qsparams).join(",")
                };

                //implement custom extend logic b/c it doesn't handle case differences in the hashes
                var tmpArray = qsparams;
                var qskeys = Object.keys(qsparams);
                var rpkeys = Object.keys(reportParams);
                var found = false;
                var qskey;
                for (var rpindex = 0; rpindex < rpkeys.length; rpindex++) { //rpindex is actually the array index, not the property
                    found = false;
                    var rpkey = rpkeys[rpindex];
                    for (var qsindex = 0; qsindex < qskeys.length; qsindex++) {
                        qskey = qskeys[qsindex];
                        if (qskey.toUpperCase() === rpkey.toUpperCase()) {
                            found = true;
                            break;
                        }
                    }
                    if (found === true) {
                        tmpArray[qskey] = reportParams[rpkey];
                    }
                    else {
                        tmpArray[rpkey] = reportParams[rpkey];
                    }
                }
                reportParams = tmpArray;

                let queryString = self.options.queryString.split("?")[1];

                var dtOptions =
                {
                    bDestroy: true,
                    pageLength: 25,
                    pagingType: "full_numbers",
                    bAutoWidth: false,
                    aaSorting: [],
                    order: [],
                    aoColumns: [],
                    language: { emptyTable: " ", processing: "Loading...<div class=\"compensafe-loadingmsg-img\"></div>" },
                    fnFooterCallback: function (nFoot, aaData, iStart, iEnd, aiDisplay) {
                        if (nFoot) {
                            var jqFoot = $(nFoot);

                            var searchText = $('#' + self._id('results') + '_filter input').val();
                            if (searchText.length > 0) {
                                jqFoot.find('th').empty();
                                jqFoot.hide();
                                return;
                            }
                            else {
                                jqFoot.show();
                            }

                            // having some weird behavior where totals from last report are showing up
                            // in new report. clearing all the cells on the total row manually resolves the issue.
                            jqFoot.find('th').empty();

                            if (data && data.Totals) {
                                var hasTotals = false;
                                $.each(data.Columns, function (i, v) {
                                    if (v.AddToTotals === true) {
                                        var total;
                                        hasTotals = true;
                                        if (v.CalculateAverageWithoutNull === false) {
                                            if (v.FormatType == "currency") {
                                                total = formatCurrencyRaw(data.Totals[v.PropertyName]);
                                            }
                                            else if (v.FormatType === "currency-2decimal" || v.FormatType === "customCurrency2") {
                                                total = formatCurrency2DecimalRaw(data.Totals[v.PropertyName]);
                                            }
                                            else if (v.FormatType == "float") {
                                                total = formatDecimal2Raw(data.Totals[v.PropertyName]);
                                            }
                                            else if (v.FormatType == "int") {
                                                total = formatNumberRaw(data.Totals[v.PropertyName]);
                                            }
                                        }
                                        else {
                                            if (v.FormatType == "currency") {
                                                total = formatCurrencyRaw(data.AveragesExcludeNulls[v.PropertyName]);
                                            }
                                            else if (v.FormatType === "currency-2decimal" || v.FormatType === "customCurrency2") {
                                                total = formatCurrency2DecimalRaw(data.AveragesExcludeNulls[v.PropertyName]);
                                            }
                                            else if (v.FormatType == "float") {
                                                total = formatDecimal2Raw(data.AveragesExcludeNulls[v.PropertyName]);
                                            }
                                            else if (v.FormatType == "int") {
                                                total = formatNumberRaw(data.AveragesExcludeNulls[v.PropertyName]);
                                            }
                                        }

                                        $('.' + v.PropertyName + 'Total').html(total);
                                    }
                                });
                                if (hasTotals) {
                                    jqFoot.children("th:first").prepend('<span>Total:</span>');
                                }
                            }
                        }
                    },
                    "processing": true,
                    "serverSide": true,
                    "ajax": {

                        // set dataType to datatables-asmxjson to use the ajaxPrefixFilter
                        // to override changes DataTables makes to ajax call
                        dataType: 'datatables-asmxjson',
                        url: reportsMovedToIcApi.has(reportParams.ID) ? `${self.options.csApiUrl}/reports/${reportParams.ID}/data?${queryString}` : self._url('Reports/PagedReport'),
                        type: "POST",
                        data: reportParams,
                        dataSrc: function (resp) {
                            data = resp.data.MetaData;
                            return resp.data.PageData;
                        },
                        AdditionalParamsList: "",
                        // if you don't include this converters section, you will get an
                        // error when the data is returned that there is no conversion
                        // between text and datatables-asmxjson
                        converters: {
                            "json datatables-asmxjson": true,
                            "datatables-asmxjson json": function (result) {
                                return result;
                            }
                        }
                    }
                };

                var elResult = document.getElementById(self._id('results'));
                var jqResults = $('#' + self._id('results'));

                if ($.fn.DataTable.fnIsDataTable(elResult)) {
                    try {
                        jqResults.dataTable().fnDestroy();
                    }
                    catch (e) {
                    }
                }

                jqResults.empty();

                $('<tfoot><tr></tr></tfoot>').appendTo(jqResults);
                var jqFoot = jqResults.find('tfoot tr');

                $.each(data.Columns, function (i, v) {
                    var col =
                    {
                        mDataProp: v.PropertyName,
                        mData: v.PropertyName,
                        sTitle: v.Label,
                        bVisible: v.IsVisible,
                        bSortable: v.IsSortable
                    };

                    var idx = -9999;
                    if (typeof v.SortColumn !== 'undefined' && null !== v.SortColumn && v.SortColumn.length !== 0) {
                        var sortColumn = v.SortColumn;
                        $.each(data.Columns, function (i, v) {
                            if (v.PropertyName === sortColumn) {
                                idx = i;
                                return false;
                            }
                        });
                        if (idx >= 0) {
                            col.iDataSort = idx;
                            var sortItem = new Array();
                            sortItem.push(idx);
                            sortItem.push('asc');
                            dtOptions.order.push(sortItem);
                            dtOptions.aaSorting.push(idx);
                        }
                    }

                    if (v.FormatType === "currency") {
                        col.sClass = "number";
                        col.mRender = formatCurrency;
                    }
                    else if (v.FormatType === "currency-2decimal") {
                        col.sClass = "number";
                        col.mRender = formatCurrency_2Decimal;
                    }
                    else if (v.FormatType === "float") {
                        col.sClass = "number";
                        col.mRender = formatDecimal2;
                    }
                    else if (v.FormatType === "int") {
                        col.sClass = "number";
                        col.mRender = formatNumber;
                    }
                    else if (v.FormatType === "date-MMDDYYYY") {
                        col.sClass = "date";
                        col.mRender = formatDateMMDDYYYY;
                    }
                    else if (v.FormatType === "percent") {
                        col.sClass = "number";
                        col.mRender = formatPercentage;
                    }
                    else if (v.FormatType === "percent3decimal") {
                        col.sClass = "number";
                        col.mRender = formatPercentage_3Decimal;
                    }
                    else if (v.FormatType === "percent1decimal") {
                        col.sClass = "number";
                        col.mRender = formatPercentage_1Decimal;
                    }
                    else if (v.FormatType === "percent100") {
                        col.sClass = "number";
                        col.mRender = formatPercentage100;
                    }
                    else if (v.FormatType === "3decimal") {
                        col.sClass = "number";
                        col.mRender = formatDecimal3;
                    }
                    else if (v.FormatType === "4decimal") {
                        col.sClass = "number";
                        col.mRender = formatDecimal4;
                    }
                    else if (v.FormatType === "month") {
                        col.mRender = formatMonth;
                    }
                    else if (v.FormatType === "monthyear") {
                        col.mRender = formatMonthYear;
                    }
                    else if (v.FormatType === "date-MMDDYY") {
                        col.sClass = "date";
                        col.mRender = formatDateMMDDYY;
                    }
                    else if (v.FormatType === "date-MMDDYYYYHHMM") {
                        col.sClass = "date";
                        col.mRender = formatDateMMDDYYYYHHMM;
                    }
                    else if (v.FormatType === "date-MMDDYYYYHHMMD") {
                        col.sClass = "date";
                        col.mRender = formatDateMMDDYYYYHHMMD;
                    }

                    else if (v.FormatType === "date-MMDDYYYYD") {
                        col.sClass = "date";
                        col.mRender = formatDateMMDDYYYYD;
                    }
                    else if (v.FormatType === "date-PeriodStartStopMMDDYYYY") {
                        col.sClass = "date";
                        col.mRender = formatDatePeriodStartStop;
                    }
                    else if (v.FormatType === "date-PeriodActiveInactiveMMDDYYYY") {
                        col.sClass = "date";
                        col.mRender = formatDatePeriodActiveInactive;
                    }
                    else if (v.FormatType === "address-brfull") {
                        col.mRender = formatAddressBrFull;
                    }
                    else if (v.FormatType === "view") {
                        col.sClass = "view";
                        col.mRender = formatCmdView;
                    }
                    else if (v.FormatType === "edit") {
                        col.sClass = "edit";
                        col.mRender = formatCmdEdit;
                    }
                    else if (v.FormatType === "add") {
                        col.sClass = "add";
                        col.mRender = formatCmdAdd;
                    }
                    else if (v.FormatType === "yesno") {
                        col.sClass = "yesno";
                        col.mRender = formatYesNo;
                    }
                    else if (v.FormatType === "nullToNA") {
                        col.sClass = "nullToNA";
                        col.mRender = formatNullToNA;
                    }
                    else if (v.FormatType === "tierPayAmount") {
                        col.sClass = "number";
                        col.mRender = formatTierPayAmount;
                    }
                    else if (v.FormatType === "custom") {
                        var tmpF = window[v.CustomFormatFunction];
                        if (typeof tmpF === "function") {
                            col.mRender = tmpF;
                        }
                    }
                    else if (v.FormatType === "customNumber" || v.FormatType === "customCurrency2") {
                        var tmpFCustomNumber = window[v.CustomFormatFunction];
                        if (typeof tmpFCustomNumber === "function") {
                            col.sClass = "number";
                            col.mRender = tmpFCustomNumber;
                        }
                    }

                    //encode &, ", ', <, > to prevent cross-site scripting
                    else {
                        col.mRender = formatTextToPreventXSS;
                    }

                    if (v.HyperLinkUrl !== null && typeof v.HyperLinkUrl !== "undefined" && v.HyperLinkUrl !== "") {
                        switch (v.FormatType) {
                            case 'currency':
                            case 'currency-2decimal':
                            case 'float':
                            case 'int':
                            case 'percent':
                            case 'percent3decimal':
                            case 'percent1decimal':
                            case 'percent100':
                            case '3decimal':
                                col.sType = 'num-html';
                                break;
                        }

                        if (typeof col.mRender === "function") {
                            var mRenderOrig = col.mRender;
                            col.mRender = function (d, t, r) {
                                var mRenderRc = mRenderOrig(d, t, r);

                                // if original data value is zero and v.HyperLinkRenderIfZero is false,
                                // then do not render a hyperlink.
                                // if HyperLinkRenderIfZero, then always render the hyperlink.
                                if (d !== 0 || v.HyperLinkRenderIfZero === true) {
                                    mRenderRc = _RenderHyperLink(mRenderRc, t, r);
                                }
                                return mRenderRc;
                            };
                        }
                        else {
                            col.mRender = _RenderHyperLink;
                        }
                    }

                    function _RenderHyperLink(d, t, r) {
                        var rc;
                        //don't render a link if the value is null
                        if ((null !== d) && ("undefined" !== typeof (d))) {
                            var query = "";
                            if (v.HyperLinkKeys !== null) {
                                query = "?";
                                $.each(v.HyperLinkKeys, function (i, val) {
                                    if (i !== 0) {
                                        query += "&";
                                    }

                                    var curV = val.ConstantValue;
                                    if (curV === null || typeof curV === "undefined") {
                                        curV = r[val.PropertyName];

                                        //if the value is truly NULL, then send an empty string on the query string instead of "null"
                                        if (curV === null || typeof curV === "undefined") {
                                            curV = '';
                                        }
                                    }
                                    query += encodeURIComponent(val.QueryStringName) + "=" + encodeURIComponent(curV);
                                });
                            }
                            if (v.AngularHyperLinksKeys != null) {
                                query = ""
                                for (var i = 0; i < v.AngularHyperLinksKeys.length; ++i) {
                                    const hlk = v.AngularHyperLinksKeys[i];
                                    query += encodeURIComponent(r[hlk.PropertyName]) + "/";
                                }
                            }
                            var anchor = "";
                            if (v.HyperLinkAnchor !== null) {
                                anchor = "#" + v.HyperLinkAnchor;
                            }
                            var target = "";
                            if (v.IsTargetBlank === true) {
                                target = " target='_blank'";
                            }

                            rc = "<a href='" + ResolveUrl(v.HyperLinkUrl) + query + anchor + "'" + target + " class='compensafe-report-hyperlinkcell'>" + d + "</a>";
                        }
                        else {
                            rc = ""; // Won't sort properly if left null
                        }

                        return rc;
                    }

                    dtOptions.aoColumns.push(col);

                    if (v.AddToTotals === true) {
                        $('<th></th>').addClass(v.PropertyName + 'Total').appendTo(jqFoot);
                    }
                    else {
                        $('<th></th>').appendTo(jqFoot);
                    }
                });

                jqResults.dataTable(dtOptions);
            },
            _reportInputChanged: function () {
                var self = this;
                var p = self.getReportParams();
                if (p.reportID !== null && typeof (p.reportID) !== "undefined") {
                    // if the ReportID changed (reportIDChanged flag), then check the DefaultDateRange property
                    if (self.options.reportIDChanged === true) {
                        $.ajax({
                            type: 'POST',
                            url: self._url('Reporting/ReportData.asmx/GetReportInfoModel'),
                            contentType: 'application/json; charset=utf-8',
                            dataType: 'json',
                            data: JSON.stringify({ ReportID: self.options.reportID }),
                            success: function (d) {
                                // reset reportIDChanged flag
                                self.options.reportIDChanged = false;

                                var r = d.d;

                                if (null === r) {
                                    window.location = ResolveUrl('~/');
                                    return;
                                }

                                if(r.IsUpgraded === true){
                                    var queryParams = self._paramParse(self.options.queryString);
                                    delete queryParams.REPORTID;
                                    if(Object.keys(queryParams).length > 0){
                                        var queryString = $.param(queryParams);
                                        window.location = ResolveUrl('~/ng/report/' + self.options.reportID + '?' + queryString);
                                    }
                                    else{
                                        window.location = ResolveUrl('~/ng/report/' + self.options.reportID);
                                    }
                                    return;
                                }

                                // Branch Employee
                                var jqBe = $('#' + self._id('be'));
                                //todo: jqBe will not be a branchEmployee widget unless already initialized

                                var jqBeSelection = {};
                                if (jqBe.is(":data('compensafe-branchEmployee')")) {
                                    jqBeSelection = jqBe.branchEmployee("getSelection");
                                }

                                var jqBeParams = $.extend(self.branchEmployeeOp, jqBeSelection);

                                //todo: only destroy and re-create if different
                                var beOptsChanged = false;
                                if (self.options.showRegionBranchEmployee !== r.RegionBranchEmployeeInput) {
                                    beOptsChanged = true;
                                    self.options.showRegionBranchEmployee = r.RegionBranchEmployeeInput;
                                }

                                if (true === r.RegionBranchEmployeeInput) {
                                    if (self.options.accessLevel >= 4) {
                                        self.branchEmployeeOp.showRegionSelector = r.RegionInput;
                                    }

                                    if (self.options.accessLevel >= 3) {
                                        self.branchEmployeeOp.showBranchSelector = r.BranchInput;
                                    }

                                    if (self.options.accessLevel > 1) {
                                        self.branchEmployeeOp.showEmployeeSelector = r.EmployeeInput;
                                    }
                                }

                                if (self.branchEmployeeOp.accessLevelType !== r.AccessLevelTypeName) {
                                    beOptsChanged = true;
                                    self.branchEmployeeOp.accessLevelType = r.AccessLevelTypeName;
                                }

                                if (self.branchEmployeeOp.employeeTypes !== r.EmployeeTypes) {
                                    beOptsChanged = true;
                                    self.branchEmployeeOp.employeeTypes = r.EmployeeTypes;
                                }

                                if (beOptsChanged === true) {
                                    if (self.options.showRegionBranchEmployee === false) {
                                        jqBe.hide();
                                    }
                                    else {
                                        // destroy and re-create input controls
                                        jqBe.show();
                                        if (jqBe.is(":data('compensafe-branchEmployee')")) {
                                            jqBe.branchEmployee("destroy");
                                        }
                                        jqBe.branchEmployee(jqBeParams);
                                    }
                                }

                                // Date Range
                                var jqDr = $('#' + self._id('dr'));
                                var jqDrSelection = {};
                                if (jqDr.is(":data('compensafe-dateRange')")) {
                                    jqDrSelection = jqDr.dateRange("getDateRange");
                                }
                                var jqDrParams = $.extend(self.dateRangeOp, jqDrSelection);
                                var dtOptsChanged = false;

                                if (self.options.dateInputType !== r.DateInputName) {
                                    dtOptsChanged = true;
                                    self.options.dateInputType = r.DateInputName;
                                    jqDrParams.hideCustomDateInput = false;
                                    if (self.options.dateInputType === "Standard") {
                                        jqDrParams.dateRange = self.options.dateRange;
                                        jqDrParams.dateRanges = self.options.dateRanges;
                                    }
                                    else if (self.options.dateInputType === "Payroll") {
                                        jqDrParams.payrollDateRange = true;
                                        jqDrParams.dateRange = self.options.payrollDateRange;
                                        jqDrParams.payCalendars = self.options.payCalendars;
                                        jqDrParams.payCalendarID = self.options.payCalendarID;
                                        jqDrParams.payPeriodOffset = self.options.payPeriodOffset;
                                        jqDrParams.payPeriodOffsetMode = self.options.payPeriodOffsetMode;
                                    }
                                    else if (self.options.dateInputType === "PtdMtd") {
                                        jqDrParams.dateRange = self.options.dateRange;
                                        jqDrParams.dateRanges = ['prev', 'mtd'];
                                        jqDrParams.hideCustomDateInput = true;
                                    }
                                    else if (self.options.dateInputType === "PytdYtd") {
                                        jqDrParams.dateRange = self.options.dateRange;
                                        jqDrParams.dateRanges = [{ label: 'Prev Yr', value: 'prevyr' }, { label: 'Curr Yr', value: 'ytd' }];
                                        jqDrParams.hideCustomDateInput = true;
                                    }
                                }

                                if (dtOptsChanged === true) {
                                    if (self.options.dateInputType === "None") {
                                        //todo: destroy or hide?
                                        jqDr.hide();
                                    }
                                    else {
                                        jqDr.show();
                                        if (jqDr.is(":data('compensafe-dateRange')")) {
                                            jqDr.dateRange("destroy");
                                        }
                                        jqDr.dateRange(jqDrParams).dateRange({ disableChangeEvent: false });
                                    }
                                }

                                //todo: move this above the create command and set the option instead of calling setDateRange
                                if (r.DefaultDateRange !== null && typeof r.DefaultDateRange !== "undefined") {
                                    jqDr.dateRange("setDateRange", r.DefaultDateRange, true);
                                }

                                // Active
                                var jqAct = $('#' + self._id('active-control'));
                                var jqAl = $('#' + self._id('active-label'));

                                jqAct.find('input[name=report-active][value="' + self.options.active + '"]').closest('label').bootstrapBtn('toggle');

                                var actOptsChanged = false;
                                if (self.options.showActive !== r.ActiveInput || self.options.activeLabel !== r.ActiveLabel) {
                                    actOptsChanged = true;
                                    self.options.showActive = r.ActiveInput;
                                    self.options.activeLabel = r.ActiveLabel;
                                }

                                if (actOptsChanged === true) {
                                    if (self.options.showActive === false) {
                                        jqAct.hide();
                                    }
                                    else {
                                        jqAct.show();
                                    }

                                    if (self.options.activeLabel !== '' && self.options.activeLabel != null) {
                                        jqAl.text(self.options.activeLabel + ':');
                                    }
                                    else {
                                        jqAl.text('');
                                    }
                                }

                                self._populateResults();
                            }
                        });
                    }
                    else {
                        self._populateResults();
                    }
                }
            },
            _setOption: function (key, value) {
                var self = this;
            },
            destroy: function () {
                // In jQuery UI 1.8, you must invoke the destroy method from the base widget
                $.Widget.prototype.destroy.call(this);
                // In jQuery UI 1.9 and above, you would define _destroy instead of destroy and not call the base method
            },
            getReportParams: function () {
                var self = this;
                var jqBe = $('#' + self._id('be'));
                var jqDr = $('#' + self._id('dr'));
                var act = $('#' + self._id('active-group') + ' label.active > input').val();

                var rc = {};

                // check to see if control exists. if it does then read value
                if (self.options.showRegionBranchEmployee === true && jqBe.is(":data('compensafe-branchEmployee')") === true) {
                    rc = $.extend(rc, jqBe.branchEmployee("getSelection"));
                }
                else {
                    rc = $.extend(rc, {
                        regionID: 0,
                        branchID: 0,
                        employeeID: 0
                    });
                }

                if (self.options.dateInputType !== "None" && jqDr.is(":data('compensafe-dateRange')") === true) {
                    rc = $.extend(rc, jqDr.dateRange("getDateRange"));
                    rc = $.extend(rc, jqDr.dateRange("getPayCalendar"));
                    rc = $.extend(rc, jqDr.dateRange("getPayPeriodOffset"));
                }
                else {
                    rc = $.extend(rc, {
                        from: new Date(),
                        to: new Date(),
                        payCalendarID: 0,
                        payPeriodOffset: 0,
                        payPeriodOffsetMode: 'paydate'
                    });
                }

                if (self.options.showActive === true && act != null) {
                    rc = $.extend(rc, {
                        active: act
                    });
                }
                else {
                    rc = $.extend(rc, {
                        active: 1
                    });
                }

                rc.reportID = self.options.reportID;

                return rc;
            }
        });

    function formatCmdView(data, type, full) {
        return "View";
    }

    function formatCmdEdit(data, type, full) {
        return "Edit";
    }

    function formatCmdAdd(data, type, full) {
        return "Add";
    }
})(jQuery);

/**
 * Compensafe Report Directory v1.2
 *
 * Depends On:
 *  JQuery 1.7.2
 *  JQueryUI 1.8.19
 *  DataTables
 *
 *  Options:
 *
 *  Public API:
 *
 */
(function ($) {
    /// jquery ui widget
    $.widget("compensafe.reportdir",
        {
            options:
            {
                baseUrl: null
            },
            _create: function () {
                var self = this;
                self._createPrefix();
                self.element.addClass('ui-widget');
                self.element.addClass(self._cssClass());

                var htmlTemplate =
                    '<div id="' + self._id('header') + '" class="' + self._cssClass("header") + '" >' +
                    '	<div>' +
                    '		<h1>Report Directory</h1>' +
                    '	</div>' +
                    '	<div class="form-inline">' +
                    '		<label>Search:' +
                    '		<input type="text" id="' + self._id('txtSearch') + '" class="form-control input-sm" /></label>' +
                    '		<input type="button" id="' + self._id('btnSearch') + '" value="Go" class="btn btn-sm btn-default" />' +
                    '		<input type="button" id="' + self._id('btnClear') + '" value="Clear" class="btn btn-sm btn-default" />' +
                    '	</div>' +
                    '</div>' +
                    '<br style="clear: both;" />' +
                    '<div id="' + self._id('acc') + '" class="' + self._cssClass("acc") + '"></div>';

                var $dr = $(htmlTemplate);
                self.element.append($dr);

                self._loadMenu();

                $('#' + self._id('acc')).addClass("ui-accordion ui-accordion-icons ui-widget ui-helper-reset")
                    .find("h3")
                    .addClass("ui-accordion-header ui-helper-reset ui-state-default ui-corner-top ui-corner-bottom")
                    .hover(function () { $(this).toggleClass("ui-state-hover"); })
                    .prepend('<span class="ui-icon ui-icon-triangle-1-e"></span>')
                    .on('click', function () {
                        $(this)
                            .toggleClass("ui-accordion-header-active ui-state-active ui-state-default ui-corner-bottom")
                            .find("> .ui-icon").toggleClass("ui-icon-triangle-1-e ui-icon-triangle-1-s").end()
                            .next().slideToggle();
                        return false;
                    })
                    .next()
                    .addClass("ui-accordion-content  ui-helper-reset ui-widget-content ui-corner-bottom")
                    .hide();
                $('#' + self._id('acc')).show();

                $('#' + self._id('btnExpand')).on("click", function () {
                    expandAllCategories();
                });

                $('#' + self._id('btnCollapse')).on("click", function () {
                    collapseAllCategories();
                });

                $('#' + self._id('btnClear')).on("click", function () {
                    $('#' + self._id('txtSearch')).val('');
                    self._loadMenu();

                    $('#' + self._id('acc')).addClass("ui-accordion ui-accordion-icons ui-widget ui-helper-reset")
                        .find("h3")
                        .addClass("ui-accordion-header ui-helper-reset ui-state-default ui-corner-top ui-corner-bottom")
                        .hover(function () { $(this).toggleClass("ui-state-hover"); })
                        .prepend('<span class="ui-icon ui-icon-triangle-1-e"></span>')
                        .on('click', function () {
                            $(this)
                                .toggleClass("ui-accordion-header-active ui-state-active ui-state-default ui-corner-bottom")
                                .find("> .ui-icon").toggleClass("ui-icon-triangle-1-e ui-icon-triangle-1-s").end()
                                .next().slideToggle();
                            return false;
                        })
                        .next()
                        .addClass("ui-accordion-content  ui-helper-reset ui-widget-content ui-corner-bottom")
                        .hide();
                    $('#' + self._id('acc')).show();
                });

                $('#' + self._id('btnSearch')).on("click", function (e) {
                    var txt = $('#' + self._id('txtSearch')).val().toLowerCase();

                    if (0 == txt.length) {
                        $('#' + self._id('acc')).find('h3').each(function () {
                            var dv = $(this).next();
                            $(this).show();
                            dv.show();
                            dv.find('ul').show();
                            dv.find('ul>li').show();
                        });
                        return;
                    }

                    $('#' + self._id('acc')).find('h3').each(function () {
                        var dv = $(this).next();
                        $(this).hide();
                        dv.hide();
                        dv.find('ul').hide();
                        dv.find('ul>li').hide();
                    });

                    $('[rdesc*="' + txt + '"], [rname*="' + txt + '"]').each(function () {
                        $(this).show();
                        $(this).parent().show();
                        $(this).parent().parent().show();
                        $(this).parent().parent().prev().show();
                        $(this).parent().parent().prev().find('span').each(function () {
                            $(this).toggleClass("ui-icon-triangle-1-e ui-icon-triangle-1-s");
                        });
                    });

                    e.preventDefault();
                    return false;
                });

                $('#' + self._id('txtSearch')).on("enterKey", function (e) {
                    e.preventDefault();
                    $('#' + self._id('btnSearch')).trigger("click");
                    return false;
                });

                $('#' + self._id('txtSearch')).on("keypress", function (e) {
                    if (e.which === 13) {
                        e.preventDefault();
                        $(this).trigger("enterKey");
                        return false;
                    }
                })
                    .trigger('focus');

                // add hover to menu items
                self.element.on("mouseenter mouseleave", '.' + self._cssClass('item'), function () {
                    $(this).toggleClass(self._cssClass("item-hover"));
                });

                // open first Group (should be Favorites)
                // calling click like this means that it starts closed and then opens as if
                // someone clicked on it. would it be better to create it opened to begin with?
                self.element.find("h3").first().trigger('click');
            },
            _createPrefix: function () {
                var self = this;
                // if element has an id, then use that for prefix
                var id = self.element.attr('id');
                if (id == null) {
                    id = self.widgetBaseClass + parseInt(Math.random() * 10000);
                }

                self.options.prefix = id + '-';
            },
            _id: function (id) {
                var self = this;
                return self.options.prefix + id;
            },
            _cssClass: function (cssclass) {
                var rc = "cs-rptdir";
                if (typeof cssclass !== "undefined" && cssclass !== null) {
                    rc += ("-" + cssclass);
                }
                return rc;
            },
            _url: function (url) {
                var self = this;
                var rc;
                if (url != null && url.indexOf("~/") == 0) {
                    rc = "" + self.options.baseUrl + url.substring(2);
                }
                else {
                    rc = "" + self.options.baseUrl + url;
                }
                return rc;
            },
            _loadMenu: function () {
                var self = this;
                $.ajax({
                    type: 'GET',
                    url: self.options.csApiUrl + "/reports/directory",
                    contentType: 'application/json; charset=utf-8',
                    async: false,
                    dataType: 'json',
                    success: function (data) {
                        var $menu = $('#' + self._id('acc'));
                        $menu.hide().empty();
                        for (var idx = 0; idx < data.groups.length; idx++) {
                            var grp = data.groups[idx];
                            $menu.append($('<h3></h3>').text(grp.name));
                            var $d = $('<div></div>').addClass(self._cssClass("dir"));
                            var $ul = $('<ul></ul>').addClass(self._cssClass("dir"));
                            var favoritesGrp = false;

                            if (grp.name === "Favorites") {
                                $ul.addClass(self._cssClass("favorite"));
                                favoritesGrp = true;
                            }

                            for (var j = 0; j < grp.menuItems.length; j++) {
                                var rpt = grp.menuItems[j];
                                var $item = $("<a></a>")
                                    .attr("href", self._url(rpt.url))
                                    .attr("rid", rpt.id)
                                    .attr("data-cy", "rpt-" + rpt.id)
                                    .addClass(self._cssClass("itemlink"));

                                if (rpt.isExternal === true) {
                                    $item.addClass("rpt-external");
                                }

                                // attr rgrp is not lowercased b/c we use it when adding to Favorites
                                var $itemli = $("<li></li>")
                                    .addClass(self._cssClass("item"))
                                    .attr("rid", rpt.id.toLowerCase())
                                    .attr("rgrp", rpt.groupName)
                                    .attr("rname", rpt.name.toLowerCase())
                                    .attr("rdesc", rpt.description.toLowerCase());

                                var icon = '<i class="fa fa-bookmark-o bm" aria-hidden="true" style="padding-right: 5px"></i>';
                                if (rpt.favorite === true) {
                                    icon = '<i class="fa fa-bookmark bm" aria-hidden="true" style="padding-right: 5px"></i>';
                                }

                                $(icon)
                                    .on('click', function (e) {
                                        e.preventDefault();
                                        var $report = $(this).parent();

                                        var fav = $report.hasClass(self._cssClass("fav"));
                                        var rid = $report.attr("rid");
                                        var $favGrp = self.element.find("ul." + self._cssClass("favorite"));
                                        var reportIcon;

                                        if (fav === true) {
                                            $favGrp.find("li[rid='" + rid + "']").remove();
                                            self.element.find("li[rid='" + rid + "']").removeClass(self._cssClass("fav")).addClass(self._cssClass("notfav"));
                                            self.element.find("li[rid='" + rid + "']").find("i.bm").removeClass("fa-bookmark").addClass("fa-bookmark-o");
                                        }
                                        else {
                                            var $grp = $("<span></span>").text($report.attr("rgrp"));
                                            $report.find('i.bm').addClass("fa-bookmark").removeClass("fa-bookmark-o");
                                            $report.removeClass(self._cssClass("notfav"))
                                                .addClass(self._cssClass("fav"))
                                                .clone(true, true)
                                                .removeClass(self._cssClass("item-hover"))
                                                .appendTo($favGrp)
                                                .find("." + self._cssClass("itemlink"))
                                                .prepend($grp);
                                        }
                                        $(this).removeClass("fa-bookmark-o")
                                            .addClass("fa-bookmark");

                                        var favList = { Favorites: [] };
                                        $favGrp.find("li").each(function (i, v) {
                                            var $this = $(this);
                                            var rname = $this.attr("rid");
                                            if (typeof rname !== "undefined") {
                                                favList.Favorites.push(rname);
                                            }
                                        });
                                        $.ajax({
                                            type: fav ? 'DELETE' : 'POST',
                                            url: `${self.options.csApiUrl}/reports/directory/favorites/${rid}`,
                                            contentType: 'application/json; charset=utf-8',
                                            dataType: 'json',
                                        });

                                        return false;
                                    })
                                    .appendTo($itemli);

                                if (rpt.favorite === true) {
                                    $itemli.addClass(self._cssClass("fav"));
                                }
                                else {
                                    $itemli.addClass(self._cssClass("notfav"));
                                }

                                if (rpt.description === null || typeof rpt.description === "undefined") {
                                    $item.text(rpt.name);
                                }
                                else {
                                    $item.text(rpt.name + ' - ' + rpt.description);
                                }

                                if (favoritesGrp === true) {
                                    $("<span></span>").text(rpt.groupName).prependTo($item);
                                }

                                $itemli.append($item);
                                $ul.append($itemli);
                            }
                            $d.append($ul);
                            $menu.append($d);
                        }
                    }//end success
                });// end ajax
            },// end _loadMenu
            expandAllCategories: function () {
                $('#' + self._id('acc')).find('h3').each(function () {
                    if ($(this).find("> .ui-icon.ui-icon-triangle-1-e").css('visibility') == 'visible') {
                        $(this).trigger('click');
                        $(this).toggleClass('ui-accordion-header-active ui-state-active ui-state-default ui-corner-bottom');
                    }
                });
            },
            collapseAllCategories: function () {
                $('#' + self._id('acc')).find('h3').each(function () {
                    if ($(this).find("> .ui-icon.ui-icon-triangle-1-s").css('visibility') == 'visible') {
                        $(this).trigger('click');
                        $(this).toggleClass('ui-accordion-header-active ui-state-active ui-state-default ui-corner-bottom');
                    }
                });
            },
            _setOption: function (key, value) {
                var self = this;
            },
            destroy: function () {
                // In jQuery UI 1.8, you must invoke the destroy method from the base widget
                $.Widget.prototype.destroy.call(this);
                // In jQuery UI 1.9 and above, you would define _destroy instead of destroy and not call the base method
            }
        });
})(jQuery);